import { useQuery } from '@tanstack/react-query';
import type { CombinedSuggestionRequestResponse } from '@//app/api/suggestions/combined';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../httpClient';

const useCombinedSuggestions = (q: string) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<CombinedSuggestionRequestResponse>({
    queryKey: ['suggestionsCombined', q],
    queryFn: async ({ signal }) => {
      const url = `${apiBaseUrl}/api/suggestions/combined?q=${q}`;
      return httpClientGetJson<CombinedSuggestionRequestResponse>(url, {
        signal,
      });
    },
    enabled: !!q,
    placeholderData: (d) => d,
  });

  return query;
};

export default useCombinedSuggestions;
